const passwordStrength = {
  passwordStrength: {
    minimumCharacters: "A senha deve ter mais de oito caracteres.",
    caps: "Você deve usar uma combinação de letras maiúsculas e minúsculas.",
    specialCharacters: "Você deve incluir números e caracteres especiais.",
  },
};

export default passwordStrength;
